import { FulfillmentStatus } from '@features/page/config/constants/fulfillment-status'
import type { FulfillmentStatusType } from '@features/page/config/constants/fulfillment-status'
import type { FulfillmentItem } from '@shared/types/fulfillment-history.types'
import type { SelectedValues } from '@vp/swan'

export interface ItemDateInfo {
  labelKey: string
  date: Date
}

export const getItemDateInfo = (
  status: FulfillmentStatusType | undefined,
  fulfillment: FulfillmentItem | undefined,
  orderCreationDate: string,
): ItemDateInfo | undefined => {
  switch (status) {
    case FulfillmentStatus.DELIVERED: {
      const dateTime = fulfillment?.history?.[0]?.dateTime
      return dateTime ? { labelKey: 'contact_us.page.steps.issue_description.delivered_on_date', date: new Date(dateTime) } : undefined
    }
    case FulfillmentStatus.UNKNOWN:
    case undefined:
      return {
        labelKey: 'contact_us.page.steps.issue_description.ordered_on_date',
        date: new Date(orderCreationDate),
      }
    default: {
      const expectedDelivery = fulfillment?.expectedDeliveryDate
      return expectedDelivery ? { labelKey: 'contact_us.page.steps.issue_description.estimated_delivery_date', date: new Date(expectedDelivery) } : undefined
    }
  }
}

export const mergeSelections = (values: SelectedValues, selected: string[], orderItemIds: string[]): string[] => {
  const nowSelected = Object.keys(values).filter((k) => values[k])
  const otherSelected = selected.filter((id) => !orderItemIds.includes(id))

  return [...otherSelected, ...nowSelected]
}
